import { type RouteComponentProps } from "react-router";

import { EmailFolder } from "types/enum";

import { getSystemFilter } from "commonComponents/utilities/SystemFilters/SystemFilterUtils";

export function getMessageListPropsFromRoute(
    reactRouterProps: RouteComponentProps<{
        folder: string;
        messageId?: string;
    }>,
) {
    const systemFilter = getSystemFilter(reactRouterProps);
    let folderId: number;
    const folder = reactRouterProps.match.params.folder;

    if (folder in EmailFolder) {
        folderId = EmailFolder[folder as keyof typeof EmailFolder];
    } else {
        folderId = Number(folder);
        if (isNaN(folderId)) {
            throw new Error(`Invalid folderId: ${folder}`);
        }
    }

    let messageId: number | undefined;

    if (reactRouterProps.match.params.messageId) {
        const parsedId = Number(reactRouterProps.match.params.messageId);
        messageId = Number.isNaN(parsedId) ? undefined : parsedId;
    } else {
        messageId = undefined;
    }
    return {
        folderId,
        messageId,
        systemFilter,
    };
}
